import { render, staticRenderFns } from "./PrivacyPolicyCheck.vue?vue&type=template&id=5509e04d&scoped=true&"
import script from "./PrivacyPolicyCheck.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PrivacyPolicyCheck.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PrivacyPolicyCheck.vue?vue&type=style&index=0&id=5509e04d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509e04d",
  null
  
)

export default component.exports